import { useState } from "react";
import { Button } from "@mui/material";
import { AccessCheck, ConfirmButton, Overlay } from "@components";
import { UserRoleEnum } from "features/users/types";
import { workspacesService } from "features/workspaces/services/workspaces-service";
import { useNotification } from "@hooks/useNotifications";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const CheckProjectButton = ({ id }: { id: number }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const { showError } = useNotification();

  return (
    <AccessCheck minAccessLevel={UserRoleEnum.Manager} showAlert={false}>
      <Overlay isVisible={isProcessing} />
      <ConfirmButton
        dialogTitle=""
        dialogText="Check the validity of translations for the entire project and remove approvals if a string becomes invalid."
        onConfirm={async () => {
          setIsProcessing(true);

          try {
            await workspacesService.checkProject(id);
          } catch (error) {
            console.error(error);
            showError("Failed to check project");
          }

          setIsProcessing(false);
        }}
      >
        <Button variant="contained">Check project</Button>
      </ConfirmButton>
    </AccessCheck>
  );
};
